import { render, staticRenderFns } from "./TradeOrderNewPricesPart.vue?vue&type=template&id=5c12679c&scoped=true&"
import script from "./TradeOrderNewPricesPart.vue?vue&type=script&lang=js&"
export * from "./TradeOrderNewPricesPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12679c",
  null
  
)

export default component.exports